export const LOG_BASE_URL = 'https://log.noxiaohao.com';
export const LOG_APP_ID = 'com.bitkeep.pc';
export const LOG_APP_NAME = 'bk_web';
export const LOG_BUSINESS1 = 'wallet';
